import { render } from "./TarjetaInfoProyecto.vue?vue&type=template&id=35c44a86&scoped=true"
import script from "./TarjetaInfoProyecto.vue?vue&type=script&lang=js"
export * from "./TarjetaInfoProyecto.vue?vue&type=script&lang=js"

import "./TarjetaInfoProyecto.vue?vue&type=style&index=0&id=35c44a86&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c44a86"]])

export default __exports__